import { BaseModel } from '../base-model';
import { IDemandMult, IDemandRegion, ISmartSuggest, IDemandPerson, IDemandSite } from '.';
import { IGenericObject } from '../common';
import { IUserListingModel } from '../user';
export interface IDemandModel {
  AvailabilityDate?: string;
  Budget?: number;
  CityDesc?: string;
  Comment?: string;
  Connections?: number;
  ConstructionClosed?: boolean;
  ConstructionOpen?: boolean;
  ConstructionSemiOpen?: boolean;
  CurrencyType?: number;
  DemandMults?: IDemandMult[];
  DemandRef?: string;
  DemandRegions?: IDemandRegion[];
  District?: string;
  EPCMax?: number;
  FootprintArea?: number;
  FromDate?: string;
  GardenAreaFrom?: number;
  GardenAreaTo?: number;
  GoalId?: number;
  GoalInfo?: IGenericObject;
  GpsCityName?: string;
  GpsKm?: number;
  GroundArea?: number;
  HasAtrium?: boolean;
  HasAttic?: boolean;
  HasCellar?: boolean;
  HasElevator?: boolean;
  HasFurbished?: boolean;
  HasGarden?: boolean;
  HasOffice?: boolean;
  HasOnlyAnnuity?: boolean;
  HasOutsideSpace?: boolean;
  HasPet?: boolean;
  HasTerrace?: boolean;
  Id?: number;
  InputEntries?: ISmartSuggest[];
  Lang?: number;
  Latitude?: number;
  LayoutType?: number;
  LivingAreaFrom?: number;
  LivingAreaTo?: number;
  Longitude?: number;
  ManagerId?: number;
  ManagerInfo?: IUserListingModel[];
  MaxAppartmentFloors?: number;
  MaxBuildingFloors?: number;
  NewConstruction?: boolean;
  NonHasFurbished?: boolean;
  NumberOfBathRoomFrom?: number;
  NumberOfBathRoomTo?: number;
  NumberOfBathShowerRoomFrom?: number;
  NumberOfBathShowerRoomTo?: number;
  NumberOfBedRoomFrom?: number;
  NumberOfBedRoomTo?: number;
  NumberOfExteriorParkingFrom?: number;
  NumberOfExteriorParkingTo?: number;
  NumberOfGarageFrom?: number;
  NumberOfGarageTo?: number;
  NumberOfInteriorParkingFrom?: number;
  NumberOfInteriorParkingTo?: number;
  NumberOfShowerRoomFrom?: number;
  NumberOfShowerRoomTo?: number;
  NumberOfToiletFrom?: number;
  OfficeAreaFrom?: number;
  OfficeAreaTo?: number;
  OnlyNewConstruction?: boolean;
  OrigID?: number;
  PersonDesc?: string;
  PersonId?: number;
  PersonInfo?: IDemandPerson;
  PriceFrom?: number;
  PriceTo?: number;
  PurposeId?: number;
  PurposeInfo?: IGenericObject;
  Quiet?: number;
  RelocationPersonId?: number;
  RelocationPersonInfo?: IDemandPerson;
  School?: number;
  ShopAreaFrom?: number;
  ShopAreaTo?: number;
  SiteId?: number;
  SiteInfo?: IDemandSite;
  StatusId?: number;
  StatusInfo?: IGenericObject;
  Street?: string;
  TerraceAreaFrom?: number;
  TerraceAreaTo?: number;
  ToDate?: string;
  TotalAreaFrom?: number;
  TotalAreaTo?: number;
  Trade?: number;
  TypeDesc?: string;
  UseGps?: boolean;
  WebModified?: boolean;
  RegionEntries?: any;
  GroundWidth?: number;
    RearOrientations?: any[];
    CheckingConfictData?: string;
    ModifiedDate?: string;
}

export class DemandModel extends BaseModel<IDemandModel> implements IDemandModel {
  AvailabilityDate: string;
  Budget: number;
  CityDesc: string;
  Comment: string;
  Connections: number;
  ConstructionClosed: boolean;
  ConstructionOpen: boolean;
  ConstructionSemiOpen: boolean;
  CurrencyType: number;
  DemandMults: IDemandMult[];
  DemandRef: string;
  DemandRegions: IDemandRegion[];
  District: string;
  EPCMax: number;
  FootprintArea: number;
  FromDate: string;
  GardenAreaFrom: number;
  GardenAreaTo: number;
  GoalId: number;
  GoalInfo: IGenericObject;
  GpsCityName: string;
  GpsKm: number;
  GroundArea: number;
  HasAtrium: boolean;
  HasAttic: boolean;
  HasCellar: boolean;
  HasElevator: boolean;
  HasFurbished: boolean;
  HasGarden: boolean;
  HasOffice: boolean;
  HasOnlyAnnuity: boolean;
  HasOutsideSpace: boolean;
  HasPet: boolean;
  HasTerrace: boolean;
  Id: number;
  InputEntries: ISmartSuggest[];
  Lang: number;
  Latitude: number;
  LayoutType: number;
  LivingAreaFrom: number;
  LivingAreaTo: number;
  Longitude: number;
  ManagerId: number;
  ManagerInfo: IUserListingModel[];
  MaxAppartmentFloors: number;
  MaxBuildingFloors: number;
  NewConstruction: boolean;
  NonHasFurbished: boolean;
  NumberOfBathRoomFrom: number;
  NumberOfBathRoomTo: number;
  NumberOfBathShowerRoomFrom: number;
  NumberOfBathShowerRoomTo: number;
  NumberOfBedRoomFrom: number;
  NumberOfBedRoomTo: number;
  NumberOfExteriorParkingFrom: number;
  NumberOfExteriorParkingTo: number;
  NumberOfGarageFrom: number;
  NumberOfGarageTo: number;
  NumberOfInteriorParkingFrom: number;
  NumberOfInteriorParkingTo: number;
  NumberOfShowerRoomFrom: number;
  NumberOfShowerRoomTo: number;
  NumberOfToiletFrom: number;
  OfficeAreaFrom: number;
  OfficeAreaTo: number;
  OnlyNewConstruction: boolean;
  OrigID: number;
  PersonDesc: string;
  PersonId: number;
  PersonInfo: IDemandPerson;
  PriceFrom: number;
  PriceTo: number;
  PurposeId: number;
  PurposeInfo: IGenericObject;
  Quiet: number;
  RelocationPersonId: number;
  RelocationPersonInfo: IDemandPerson;
  School: number;
  ShopAreaFrom: number;
  ShopAreaTo: number;
  SiteId: number;
  SiteInfo: IDemandSite;
  StatusId: number;
  StatusInfo: IGenericObject;
  Street: string;
  TerraceAreaFrom: number;
  TerraceAreaTo: number;
  ToDate: string;
  TotalAreaFrom: number;
  TotalAreaTo: number;
  Trade: number;
  TypeDesc: string;
  UseGps: boolean;
  WebModified: boolean;
  RegionEntries: any;
  GroundWidth?: number;
    RearOrientations?: any[];
    CheckingConfictData?: string;
    ModifiedDate?: string;
  /**
   *
   */
  constructor(options?: IDemandModel) {
    super(options);
  }
}

